import { parseImportedState, replaceSavedState, serialize } from '../persistence';
import { showConfirmDialog } from '../siteEditor';
import type { State } from '../types';

// ヘッダーの「JSONエクスポート/インポート」ボタン。保存データ(localStorageと同じ形式)を
// ファイルとして書き出し/読み込みする。読み込み後はページを再読み込みして、
// 地図・サイドバーを含めた通常の起動処理で反映する(部分的な差し替えより確実なため)

function timestamp(): string {
  const d = new Date();
  const p = (n: number) => String(n).padStart(2, '0');
  return `${d.getFullYear()}${p(d.getMonth() + 1)}${p(d.getDate())}-${p(d.getHours())}${p(d.getMinutes())}`;
}

export function exportStateToFile(state: State): void {
  const json = JSON.stringify(serialize(state), null, 2);
  const url = URL.createObjectURL(new Blob([json], { type: 'application/json' }));
  const a = document.createElement('a');
  a.href = url;
  a.download = `mansion-layout-${timestamp()}.json`;
  document.body.append(a);
  a.click();
  a.remove();
  setTimeout(() => URL.revokeObjectURL(url), 1000);
}

export function wireDataTransferButtons(state: State): void {
  const exportBtn = document.getElementById('btn-export-json');
  const importBtn = document.getElementById('btn-import-json');
  const fileInput = document.getElementById('import-json-file') as HTMLInputElement | null;
  exportBtn?.addEventListener('click', () => exportStateToFile(state));
  importBtn?.addEventListener('click', () => fileInput?.click());
  fileInput?.addEventListener('change', async () => {
    const file = fileInput.files?.[0];
    fileInput.value = '';
    if (!file) return;
    let imported: ReturnType<typeof parseImportedState>;
    try {
      imported = parseImportedState(await file.text());
    } catch (e) {
      window.alert(e instanceof Error ? e.message : String(e));
      return;
    }
    showConfirmDialog(
      `「${file.name}」を読み込みます。現在の敷地・棟・駐車場などの内容はすべて置き換わります。よろしいですか?`,
      () => {
        try {
          replaceSavedState(imported);
        } catch {
          window.alert(
            '保存領域に書き込めませんでした(ブラウザの保存容量やプライベートモードを確認してください)。'
          );
          return;
        }
        location.reload();
      }
    );
  });
}
